export default "__VITE_ASSET__CAfBnBjt__"